module.exports = __webpack_public_path__ + "img/contact-bg.d19a9b0f.svg";